$( document ).ready(function() {
    $('.card').hover( (evt) => {
      
      if ($(evt.currentTarget).find(".sizes_badge").is(":visible")) {
        $(evt.currentTarget).find(".sizes_badge").hide();
      } else {
        $(evt.currentTarget).find(".sizes_badge").show();
      }
      
    } );
});